import { urls } from './';

const videos = {
  home: {
    banner_verde: urls.assets + 'videos/banner-verde-home.mp4',
    banner_azul: urls.assets + 'videos/banner-azul-home.mp4',
  }
};

export { videos };
